import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

export const useEyeColorFilter = (talentFilter, talentFilterTags) => {
  const [values, setValues] = useState([]);

  // hydrate from existing filter
  useEffect(() => {
    const attr = talentFilter?.person_attributes?.find(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.eyeColor
    );

    if (attr) setValues(attr.list || []);
  }, []);

  useEffect(() => {
    const exists = talentFilter?.person_attributes?.some(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.eyeColor
    );

    if (!exists) {
      clearEyeColor();
    }
  }, [talentFilter]);

  const clearEyeColor = () => {
    setValues([]);
  };

  const isDisabled = !values.length;

  const buildEyeColorFilter = () => {
    if (isDisabled) return null;

    const eyeColorAttribute = {
      person_attribute_uuid: uuidMapping.eyeColor,
      contains: false,
      start_value: null,
      end_value: null,
      has_all_in_list: false,
      list: values,
    };

    const tags = upsertTag(
      talentFilterTags,
      uuidMapping.eyeColor,
      values
    );

    return { attribute: eyeColorAttribute, tags };
  };

  return {
    values,
    setValues,
    isDisabled,
    buildEyeColorFilter,
    clearEyeColor
  };
};
